import React, { useState } from "react";
import { connect } from "react-redux";
import { useMountEffect } from "../../../hooks/LifeCycle";
import IngresoActions from "../../../stores/ingreso/Actions";
import useEmpresa from "../../../hooks/useEmpresa";
import Text from "../../../components/Common/Text";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import Tooltip from "../../../components/Common/Tooltip";
import CustomInput from "../../../components/CustomForm/CustomInput";
import { PrinterOutlined } from "@ant-design/icons";
import CustomTable from "../../../components/CustomTable/CustomTable";
import Space from "../../../components/Common/Space";
import { CONFIG_VOUCHER } from "../../autorizacion/utils/AutorizacionConstant";
import { isEmptyValue } from "../../../utils/StringUtil";

const MedicosParticipantesTabla = (props) => {
  const { formCierreCuentasData } = props;
  const itemsPerPage = 10;
  const [query, setQuery] = useState("");
  const empresa = useEmpresa();
  const [medicos, setMedicos] = useState([]);

  useMountEffect(() => {
    setMedicos(formCierreCuentasData?.medicosParticipantes || []);
  });

  const filtrarBusqueda = (query) => {
    if (isEmptyValue(query)) {
      setMedicos(formCierreCuentasData?.medicosParticipantes);
      return;
    }
    const medicosFiltrados =
      formCierreCuentasData?.medicosParticipantes?.filter((medico) => {
        const codigoMedicoMatch = String(medico.codigoReclamante)
          ?.toLowerCase()
          ?.includes(query.toLowerCase());

        const nombreMedicoMatch = medico.nombreReclamante
          ?.toLowerCase()
          ?.includes(query.toLowerCase());

        return codigoMedicoMatch || nombreMedicoMatch;
      });

    setMedicos(medicosFiltrados);
  };

  const onQueryChange = () => (value) => {
    setQuery(value);
    filtrarBusqueda(value);
  };

  const imprimirVoucher = (isMatricial, medico) => {
    const { numeroIngreso, anio } = formCierreCuentasData;
    const newTab = window.open(
      `/voucher-honorarios?isMatricial=${isMatricial}&numeroIngreso=${numeroIngreso}&anioIngreso=${anio}&codigoReclamante=${medico?.codigoReclamante}`,
      "_blank",
      isMatricial ? CONFIG_VOUCHER.MATRICIAL : CONFIG_VOUCHER.TERMICO
    );

    newTab.focus();
  };

  const columnasMedicosParticipantes = [
    {
      key: "tipoReclamante",
      title: "Tipo",
      dataIndex: "tipoReclamante",
    },
    {
      key: "codigoReclamante",
      title: "Código",
      dataIndex: "codigoReclamante",
    },
    {
      key: "nombreReclamante",
      title: "Nombre",
      dataIndex: "nombreReclamante",
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => (
        <Space size={10}>
          <Tooltip text="Matricial">
            <PrinterOutlined
              style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 25 }}
              onClick={() => {
                imprimirVoucher(true, record);
              }}
            />
          </Tooltip>

          <Tooltip text="Térmico">
            <PrinterOutlined
              style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 25 }}
              onClick={() => {
                imprimirVoucher(false, record);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Text size="24px" isTittle={true} weight={"bold"}>
        {"Imprimir Voucher"}
      </Text>

      <CustomInput
        type={"text"}
        placeholder={"Buscar"}
        value={query}
        onChange={onQueryChange()}
      />

      <CustomSeparator height={"10px"} />

      <CustomTable
        columns={columnasMedicosParticipantes}
        dataSource={medicos || []}
        showPagination={true}
        pageSize={itemsPerPage}
      />

      <CustomSeparator height={"20px"} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  consultarDetalleCierreCuentaLoading:
    state.ingreso.consultarDetalleCierreCuentaLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  consultarDetalleCierreCuenta: IngresoActions.consultarDetalleCierreCuenta,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(MedicosParticipantesTabla);
